import anime from 'animejs/lib/anime.es.js'
import { Block } from '@/core/Block.js'

export class PageOverlay extends Block {
  init() {
    super.init()

    this.layer1 = this.get('.c-page-overlay-layer-1')
    this.layer2 = this.get('.c-page-overlay-layer-2')
    this.timelineSpeed = .75
  }

  show() {
    const tl = anime.timeline()

    this.layer2.style.transformOrigin = 'bottom'

    tl.add({
      targets: this.layer1,
      opacity: [0, 1],
      duration: 500 * this.timelineSpeed,
      easing: 'linear',
    })

    tl.add(
      {
        targets: this.layer2,
        scaleY: [0, 1],
        duration: 500 * this.timelineSpeed,
        easing: 'easeInExpo',
        begin: () => {},
      },
      0
    )

    return tl.finished
  }

  hide() {
    const tl = anime.timeline()

    this.layer2.style.transformOrigin = 'top'

    tl.add({
      targets: this.layer1,
      opacity: [1, 0],
      duration: 500 * this.timelineSpeed,
      delay: 200 * this.timelineSpeed,
      easing: 'linear',
    })

    tl.add(
      {
        targets: this.layer2,
        scaleY: [1, 0],
        duration: 500 * this.timelineSpeed,
        easing: 'easeOutExpo',
      },
      100 * this.timelineSpeed
    )

    return tl.finished
  }
}
